export function textTheme(theme, { getColor }) {
  return {
    getCSS: ({ color, align, wrap, bold }) => {
      return {
        margin: 0,
        color: getColor(color) || theme.colors.black,
        textAlign: align,
        ...(bold && { fontWeight: theme.fontWeights[bold] }),
        ...(!wrap && {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }),
      };
    },
  };
}
